import React, { memo } from 'react';
import { NativeBaseProvider, View } from 'native-base';
import { fullAppTheme } from '../../../../shared';
import { StyleSheet } from 'react-native';
const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    flexBasis: '100%'
  }
});
export default /*#__PURE__*/memo(_ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(NativeBaseProvider, {
    theme: fullAppTheme
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.container,
    testID: "crt-full-app-page",
    key: 'crt-full-app-page',
    w: {
      base: 'full',
      sm: 'full',
      md: 645,
      lg: 645
    },
    py: {
      base: 8,
      md: 16,
      lg: 16
    }
  }, children));
});
//# sourceMappingURL=CRT.js.map